import { apiService } from './api';
import { Subject } from '../types';

export interface SubjectFormData {
  name: string;
  description?: string;
  centerId?: string;
  isActive?: boolean;
}

export const subjectService = {
  // Get all subjects for a center
  getSubjects: async (params?: {
    centerId?: string;
    isActive?: boolean;
    search?: string;
    page?: number;
    limit?: number;
  }) => {
    const response = await apiService.get<{ subjects: Subject[], pagination: any }>('/administration/subjects', params);
    return {
      subjects: response.data?.subjects || [],
      pagination: response.data?.pagination || { totalItems: 0, totalPages: 1, currentPage: 1 }
    };
  },

  // Get single subject by ID
  getSubject: async (id: string) => {
    const response = await apiService.get<Subject>(`/administration/subjects/${id}`);
    return response.data;
  },

  // Create new subject
  createSubject: async (data: SubjectFormData) => {
    const response = await apiService.post<Subject>('/administration/subjects', data);
    return response.data;
  },

  // Update subject
  updateSubject: async (id: string, data: Partial<SubjectFormData>) => {
    const response = await apiService.put<Subject>(`/administration/subjects/${id}`, data);
    return response.data;
  },

  // Delete subject
  deleteSubject: async (id: string) => {
    const response = await apiService.delete(`/administration/subjects/${id}`);
    return response.data;
  }
};
